import { ColumnModule } from 'ui/components/3-organisms/ColumnModule';
import { ModuleFeature } from 'features/Modules';

export const ColumnModuleFeature: React.FC<Content.ColumnModule> = ({ content }) => {
    const { columnContent } = content?.properties ?? {};

    return (
        <ColumnModule>
            {columnContent?.map((contentModule, index) => (
                <ModuleFeature key={index} contentModule={contentModule} />
            ))}
        </ColumnModule>
    );
};